/** World-space character orientation in exported mapping JSON. */

export const CHARACTER_AXIS_OPTIONS = [
  'X',
  '-X',
  'Y',
  '-Y',
  'Z',
  '-Z',
] as const;

export type CharacterAxis = (typeof CHARACTER_AXIS_OPTIONS)[number];

/** Default export convention: +Z forward, +Y up (common for glTF / many DCCs). */
export const DEFAULT_CHARACTER_FORWARD_AXIS: CharacterAxis = 'Z';
export const DEFAULT_CHARACTER_UP_AXIS: CharacterAxis = 'Y';

export function isCharacterAxis(value: string): value is CharacterAxis {
  return (CHARACTER_AXIS_OPTIONS as readonly string[]).includes(value);
}

/** Parse mapping JSON top-level `"forward"` / `"up"` string values. */
export function characterAxisFromMappingJson(
  value: unknown,
): CharacterAxis | null {
  return typeof value === 'string' && isCharacterAxis(value) ? value : null;
}
